import React from 'react';
import PropTypes from 'prop-types';

const ProductPicture = ({ product, imgFormat, pictureClass, imgClass }) => {
  let imageLarge = 'https://dummyimage.com/250x250/888/fff.png';
  let imageMedium = 'https://dummyimage.com/250x250/888/fff.png';
  let imageSmall = 'https://dummyimage.com/250x250/888/fff.png';
  let imageXtraSmall = 'https://dummyimage.com/250x250/888/fff.png';

  if (product.dlgImages) {
    product.dlgImages.map(item => {
      if (item.format === imgFormat) {
        imageLarge = item.l.url;
        imageMedium = item.m.url;
        imageSmall = item.s.url;
        imageXtraSmall = item.xs.url;
      }
      return null;
    });
  } else if (product.dlgImage) {
    imageLarge = product.dlgImage.l.url;
    imageMedium = product.dlgImage.m.url;
    imageSmall = product.dlgImage.s.url;
    imageXtraSmall = product.dlgImage.xs.url;
  }

  return (
    <picture className={pictureClass}>
      <source srcSet={imageLarge} media='(min-width:1200px)' />
      <source srcSet={imageMedium} media='(min-width:1024px)' />
      <source srcSet={imageSmall} media='(min-width:768px)' />
      <img className={imgClass} src={imageXtraSmall} alt={product.name} />
    </picture>
  );
};

ProductPicture.propTypes = {
  product: PropTypes.shape().isRequired,
  imgFormat: PropTypes.string,
  pictureClass: PropTypes.string,
  imgClass: PropTypes.string,
};

ProductPicture.defaultProps = {
  imgFormat: 'thumbnail',
  pictureClass: '',
  imgClass: '',
};

export default ProductPicture;
